<template>
	<div class="Top">
		<div class="current" @click="active = item.to,$emit('Select',item.to)" :class="active == item.to ? 'checkTab' : ''"
			v-for="(item,index) in topList" :key="index">{{item.name}}</div>
	</div>
</template>
<script>
	// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	export default {
		name: 'Top',
		components: {

		},
		props: {
			topList: {
				type: Array,
				default: []
			},
			//默认选择的路由
			currentComponent:{
				type:String,
				default:""
			}
		},
		// 定义属性
		data() {
			return {
				  active: this.currentComponent
			}
		},
		// 计算属性，会监听依赖属性值随之变化
		computed: {},
		// 监控data中的数据变化
		watch: {
			currentComponent(n,m) {
				this.active = n
			},
		},
		// 方法集合
		methods: {
			
		},
		// 生命周期 - 创建完成（可以访问当前this实例）
		created() {

		},
		// 生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {

		},
		beforeCreate() {}, // 生命周期 - 创建之前
		beforeMount() {}, // 生命周期 - 挂载之前
		beforeUpdate() {}, // 生命周期 - 更新之前
		updated() {}, // 生命周期 - 更新之后
		beforeDestroy() {}, // 生命周期 - 销毁之前
		destroyed() {}, // 生命周期 - 销毁完成
		activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	}
</script>

<style scoped lang="scss">
	.Top {
		display: flex;
		height: 0.6rem;
		background: white;
		border-radius: 0.1rem;
		padding: 0 0.3rem;
		justify-content: center;
		align-items: center;
		margin-bottom: 0.12rem;

		.current {
			margin-right: 0.24rem;
			cursor: pointer;
		}

		.checkTab {
			color: #2B2B2F;
			font-size: 18px;
			font-weight: 600;
		}
	}
</style>
